export default __webpack_public_path__ + "static/media/Averta-Light.6c881b21.woff";